/**
 * Quanto cada contato ainda deve, a partir dos títulos a receber em aberto.
 *
 * A lista de pacientes mostrava zero para todo mundo ("o financeiro ainda não
 * foi portado"); o financeiro foi, e o zero ficou. A conta é a mesma da ficha
 * do paciente: valor do título menos o que já foi pago, nunca abaixo de zero.
 */

export interface TituloEmAberto {
    contato_id?: unknown;
    valor_centavos?: unknown;
    pagamentos?: unknown;
}

export function emAbertoPorContato(titulos: TituloEmAberto[]): Map<string, number> {
    const saldo = new Map<string, number>();
    for (const t of titulos) {
        if (!t.contato_id) continue;
        const pagos = (Array.isArray(t.pagamentos) ? t.pagamentos : [])
            .reduce((soma: number, p: { valor_centavos?: unknown }) => soma + Number(p.valor_centavos ?? 0), 0);
        const falta = Math.max(0, Number(t.valor_centavos ?? 0) - pagos);
        const id = String(t.contato_id);
        saldo.set(id, (saldo.get(id) ?? 0) + falta);
    }
    return saldo;
}
